import { skipToken } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useGetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGet } from "vl-api/vlComponents";

interface UseFieldUniqueValuesProps {
  fieldId: string;
}

export function useFieldUniqueValues({ fieldId }: UseFieldUniqueValuesProps) {
  const { datasetId } = useParams<{ datasetId: string }>();

  const { data, isLoading, error } =
    useGetFieldUniqueValuesApiV1DatasetsDatasetIdCustomMetadataFieldsFieldIdUniqueValuesGet(
      datasetId && fieldId
        ? {
            pathParams: {
              datasetId,
              fieldId,
            },
          }
        : skipToken,
    );

  return {
    values: data || [],
    isLoading,
    error: error || null,
  };
}
